import router from "../../app/router"
import env from "@/utils/env";


// import home from "./pages/home/index"
import home from "../../components/activeOver.vue"



const routes = [{
  path: "/moonAnswer/home",
  component: home,
  meta: {
    title: "管家提示",
    auth:env.isWeixin,
    authConfig: {
      gtWechatAuth: true,
      hbWechatOpenid: true
    }
  }
}]

router.addRoutes(routes)

export default router


// WEBPACK FOOTER //
// ./src/projects/moonAnswer/router.js